import styles from "./jobs.module.css";

const JobsToolbar = ({ tabs, activeTab, onChange, counts }) => {
  return (
    <div className={styles.jobsToolbar}>
      <div className={styles.jobsTabs}>
        {tabs.map((tab) => (
          <button
            key={tab.key}
            className={`${styles.jobsTab} ${activeTab === tab.key ? styles.jobsTabActive : ""}`}
            onClick={() => onChange(tab.key)}
          >
            {tab.label}{" "}
            <span className={styles.tabCount}>{counts[tab.key] ?? 0}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default JobsToolbar;
